export function calculateAgeFromBirthDateEpochSeconds(dobEpochSeconds) {
    // Ottieni la data attuale
    const dataAttuale = new Date();

    // Crea un oggetto Date dalla data di nascita in epoch seconds
    const dataDiNascita = new Date(dobEpochSeconds * 1000); // Converti in millisecondi

    // Calcola la differenza in millisecondi
    const differenzaInMillisecondi = dataAttuale - dataDiNascita;

    // Calcola l'età in anni
    const etaInAnni = Math.floor(differenzaInMillisecondi / (1000 * 60 * 60 * 24 * 365.25)); // Considera gli anni bisestili

    return etaInAnni;
}